// hooks/useSetores.js
import { useState, useEffect, useMemo } from "react"
import CalcService from "src/services/calc-service"

export function useSetores() {
  const [options, setOptions] = useState([])
  const calcService = useMemo(() => new CalcService(), [])

  useEffect(() => {
    let mounted = true

    const fetchSetores = async () => {
      try {
        const result = await calcService.recuperaSetores()

        // Garantir formato string (label)
        const optionsAsStrings = result.map(item => {
          if (item && typeof item === "object") {
            return item.label ?? JSON.stringify(item)
          }
          return String(item)
        })

        if (mounted) setOptions(optionsAsStrings)
      } catch (err) {
        console.error("Erro ao carregar Setores:", err)
      }
    }

    fetchSetores()
    return () => { mounted = false }
  }, [calcService])

  return options
}